export default {
  en: {
    NOTE_BULK_BLOCK_NUMBER: 'Note: The selected caller IDs will be blocked for their respective campaigns noted above, unless the account wide toggle is enabled.',
    BLOCK_ACCOUNT_WIDE_LABEL: 'Block Account Wide',
    BLOCK_ACCOUNT_WIDE_TT: 'Enable toggle to block numbers account wide',
    REVIEW_CALLS: 'Review Selected Call(s)',
    ANNOTATE_CALLS: 'Annotate Calls',
    ADJUST_CALL_PAYMENTS: 'Adjust Call Payments',
    TRANSCRIBE_CALLS: 'Transcribe Calls',
    TRANSCRIBE_SEND_BTN: 'Transcribe Calls',
    TRANSCRIBE_CALLS_ATTEST: 'I confirm the list of calls to transcribe is correct.',
    TRANSCRIBE_CALLS_FEE_MESSAGE: '<strong>Important</strong>: Additional fees apply based on the length of the call to transcribe. See Settings > Billing Settings and click View Current Pricing for details.',
    TRANSCRIBE_CALLS_NUMBER: 'Transcribe {adjustmentCount} call(s)',
    TRANSCRIBE_CALLS_MESSAGE: 'All calls ({adjustmentCount}) in the current report will be transcribed. The transcripts will be available shortly. Click the icon in the Transcript column for each call to view it.',
    TRANSCRIBE_SELECTED_CALLS_MESSAGE: 'If the above list of calls to transcribe is correct, confirm the list and click Transcribe Calls. The transcripts will be available shortly. Click the icon in the Transcript column for each call to view it.'
  }
};